exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".otp-block-input input[type=number]::-webkit-outer-spin-button, .otp-block-input input[type=number]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.otp-block-input input[type=number] {\n  -moz-appearance: textfield;\n}\n.otp-block-input .pin-input-group {\n  position: relative;\n}\n.otp-block-input .pin-input-focus-div {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  opacity: 0;\n}", ""]);

// exports
